export default {
  authSkipRoutes: ['empty', 'packageDetails', 'checkIdCard']
}



// WEBPACK FOOTER //
// ./src/config/index.js